export default
{
    previousText: 'Anterior',
    nextText: 'Siguiente',
    loadingText: 'Cargando...',
    noDataText: 'Tabla vacía',
    pageText: 'Página',
    ofText: 'de',
    rowsText: 'filas',
};